import { api } from './requestGraphql';

const getAffiliateAlerts = async (pagination, sorting, filters) => {

    let preparedFilters = '';

    for (const filter in filters) {
        preparedFilters += (!!filters[filter]) ?
            `${filter}: "${filters[filter]}"` : '';
    }

    try {
        const res = await api.post(
            '', {
                query: `
                {
                    getAffiliateAlerts(
                        pagination: { page: ${pagination.page}, limit: ${pagination.limit} }, 
                        sorting: { orderBy: "${sorting.orderBy}", orderDirectionAsc: ${sorting.orderDirectionAsc} }
                        filters: { ${preparedFilters} }
                    ) {
                        count
                        data {
                            id
                            name
                            type
                            message
                            user
                            status
                            dateAdded
                            dateUpdated
                        }
                    }
                }
                `,
            }
        );

        let response = res.data.data.getAffiliateAlerts;
        // console.log(`getAffiliateAlerts response:`, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const getAffiliateAlertsFilterData = async () => {
    try {
        const res = await api.post('', {
            query: `
                {
                    getAffiliateAlertsFilterData {
                        filters {
                            id {
                                key
                                value
                            }
                            name {
                                key
                                value
                            }
                            type {
                                key
                                value
                            }
                            status {
                                key
                                value
                            }
                        }
                    }
                }
            `,
        });

        let response = res.data.data.getAffiliateAlertsFilterData;
        // console.log(`getAffiliateAlertsFilterData response:`, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const createOrUpdateAffiliateAlert = async (data) => {
    let { id, name, type, message, user, status, isEdit } = data;

    try {
        const res = await api.post('', {
            query: `
                mutation {
                    createOrUpdateAffiliateAlerts(
                        data: {
                            id: ${id || null}
                            isEdit: ${isEdit || false}
                            name: "${name}"
                            type: ${type}
                            message: "${message}"
                            user: "${user}"
                            status: ${status || 'inactive'}
                        }
                    ) {
                        id
                        isSuccess
                    }
                }
            `,
        });

        let response = res.data.data.createOrUpdateAffiliateAlerts;
        // console.log(`createOrUpdateAffiliateAlert response:`, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const deleteAffiliateAlert = async (id) => {
    try {
        const res = await api.post('', {
            query: `
                mutation {
                    deleteAffiliateAlert(id: ${id})
                }
            `,
        });

        let response = res.data.data.deleteAffiliateAlert;
        // console.log(`deleteAffiliateAlert response:`, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const getAffiliateAlertsHistoryById = async (id) => {
    try {
        const res = await api.post('', {
            query: `
                {
                    getAffiliateAlertsHistoryById(id: ${id}) {
                        entity
                        user
                        action
                        dateAdded
                        logs
                    }
                }
            `,
        });

        return res.data.data.getAffiliateAlertsHistoryById;
    } catch (e) {
        console.error(e);
        throw e;
    }
};

export default {
    getAffiliateAlerts,
    getAffiliateAlertsFilterData,
    createOrUpdateAffiliateAlert,
    deleteAffiliateAlert,
    getAffiliateAlertsHistoryById,
};
